export const mono = "'JetBrains Mono', 'Fira Code', 'Courier New', monospace";
export const fontPrimary = mono;
